export const OBTENER_LISTADO_CLIENTES = 'OBTENER_LISTADO_CLIENTES';
export const CLIENTES_TOTALES = 'CLIENTES_TOTALES';
export const PAGINADO_CLIENTES = 'PAGINADO_CLIENTES';
